import { DATE_FORMAT, DISPLAY_TIME_FORMAT, TIME_FORMAT, weekDaysOptions } from "../constants";
import { timeToMoment } from "./time";
import moment from '../moment/moment';
import { filterObjectKeys, isEqual, sanitizeObject, sortByIdCallback, toSorted } from "./utils";
import { TIME_REGEX } from "@/regexes";
import { setTimeFromString } from "./reservations";


export const getInitOpeningHourForm = () => {
    return {
        id: { value: null, modified: false, type: "id", valid: true },
        weekday: { value: weekDaysOptions[0].value, modified: false, type: "weekday", valid: true },
        from_hour: { value: "", modified: false, type: "time", valid: false },
        to_hour: { value: "", modified: false, type: "time", valid: false },
    }
};

export const openingHourToForm = (openingHour) => {
    return {
        id: { value: openingHour.id, modified: false, type: "id", valid: true },
        weekday: { value: openingHour.weekday, modified: false, type: "weekday", valid: true },
        from_hour: { value: openingHour.from_hour, modified: false, type: "time", valid: false },
        to_hour: { value: openingHour.to_hour, modified: false, type: "time", valid: false },
    }
};

export const formToOpeningHour = (form) => {
    return {
        id: form.id.value,
        weekday: form.weekday.value,
        from_hour: form.from_hour.value,
        to_hour: form.to_hour.value,
    }
}

export const getInitDefaultShiftForm = () => {
    return {
        id: { value: null, modified: false, type: "id", valid: true },
        weekday: { value: weekDaysOptions[0].value, modified: false, type: "weekday", valid: true },
        from_hour: { value: "", modified: false, type: "time", valid: false },
        to_hour: { value: "", modified: false, type: "time", valid: false },
        min_seats: { value: 1, modified: false, type: "min_seats", valid: true },
        max_seats: { value: 16, modified: false, type: "max_seats", valid: true },
        interval: { value: 30, modified: false, type: "integer", valid: true },
        active: { value: true, modified: false, type: "boolean", valid: true },
        shift_seats_limit: { value: 1, modified: false, type: "shift_seats_limit", valid: true },
        shift_limit_active: { value: false, modified: false, type: "shift_limit_active", valid: true },
        interval_seats_limit: { value: 1, modified: false, type: "interval_seats_limit", valid: true },
        interval_limit_active: { value: false, modified: false, type: "interval_limit_active", valid: true },
        override_before_service: { value: false, modified: false, type: "boolean", valid: true },
        duration_before_service: { value: false, modified: false, type: "boolean", valid: true },
        reservation_before_duration: { value: '01:00:00', modified: false, type: 'duration', valid: true },
        message: { value: "", modified: false, type: 'string', valid: true },
        show_message: { value: false, modified: false, type: "boolean", valid: true },
    }
};

export const defaultShiftToForm = (shift) => {
    return {
        id: { value: shift.id, modified: false, type: "id", valid: true },
        weekday: { value: shift.weekday, modified: false, type: "weekday", valid: true },
        from_hour: { value: shift.from_hour, modified: false, type: "time", valid: true },
        to_hour: { value: shift.to_hour, modified: false, type: "time", valid: true },
        min_seats: { value: shift.min_seats, modified: false, type: "min_seats", valid: true },
        max_seats: { value: shift.max_seats, modified: false, type: "max_seats", valid: true },
        interval: { value: shift.interval, modified: false, type: "integer", valid: true },
        active: { value: shift.active, modified: false, type: "boolean", valid: true },
        shift_seats_limit: { value: shift.shift_seats_limit, modified: false, type: "shift_seats_limit", valid: true },
        shift_limit_active: { value: shift.shift_limit_active, modified: false, type: "shift_limit_active", valid: true },
        interval_seats_limit: { value: shift.interval_seats_limit, modified: false, type: "interval_seats_limit", valid: true },
        interval_limit_active: { value: shift.interval_limit_active, modified: false, type: "interval_limit_active", valid: true },
        override_before_service: { value: shift.override_before_service, modified: false, type: "boolean", valid: true },
        duration_before_service: { value: shift.duration_before_service, modified: false, type: "boolean", valid: true },
        reservation_before_duration: { value: shift.reservation_before_duration, modified: false, type: 'duration', valid: true },
        message: { value: shift.message, modified: false, type: 'string', valid: true },
        show_message: { value: shift.show_message, modified: false, type: "boolean", valid: true },
    }
};

export const formToDefaultShift = (form) => {
    return {
        id: form.id.value,
        weekday: form.weekday.value,
        from_hour: form.from_hour.value,
        to_hour: form.to_hour.value,
        min_seats: form.min_seats.value,
        max_seats: form.max_seats.value,
        interval: form.interval.value,
        active: form.active.value,
        shift_limit_active: form.shift_limit_active.value,
        shift_seats_limit: form.shift_seats_limit.value,
        interval_limit_active: form.interval_limit_active.value,
        interval_seats_limit: form.interval_seats_limit.value,
        override_before_service: form.override_before_service.value,
        duration_before_service: form.duration_before_service.value,
        reservation_before_duration: form.reservation_before_duration.value,
        message: form.message.value,
        show_message: form.show_message.value,
    }
}

export const getInitCustomShiftForm = () => {
    return {
        id: { value: null, modified: false, type: "id", valid: true },
        date: { value: "", modified: false, type: "date", valid: true },
        shift: { value: null, modified: false, type: "shift", valid: true },
        from_hour: { value: "", modified: false, type: "time", valid: false },
        to_hour: { value: "", modified: false, type: "time", valid: false },
        min_seats: { value: 1, modified: false, type: "min_seats", valid: true },
        max_seats: { value: 16, modified: false, type: "max_seats", valid: true },
        interval: { value: 30, modified: false, type: "integer", valid: true },
        active: { value: true, modified: false, type: "boolean", valid: true },
        shift_seats_limit: { value: 1, modified: false, type: "shift_seats_limit", valid: true },
        shift_limit_active: { value: false, modified: false, type: "shift_limit_active", valid: true },
        interval_seats_limit: { value: 1, modified: false, type: "interval_seats_limit", valid: true },
        interval_limit_active: { value: false, modified: false, type: "interval_limit_active", valid: true },
        override_before_service: { value: false, modified: false, type: "boolean", valid: true },
        duration_before_service: { value: false, modified: false, type: "boolean", valid: true },
        reservation_before_duration: { value: '01:00:00', modified: false, type: 'duration', valid: true },
        message: { value: "", modified: false, type: 'string', valid: true },
        show_message: { value: false, modified: false, type: "boolean", valid: true },
    }
};

export const customShiftToForm = (shift) => {
    return {
        id: { value: shift.id, modified: false, type: "id", valid: true },
        date: { value: shift.date, modified: false, type: "date", valid: true },
        shift: { value: shift.shift, modified: false, type: "shift", valid: true },
        from_hour: { value: shift.from_hour, modified: false, type: "time", valid: true },
        to_hour: { value: shift.to_hour, modified: false, type: "time", valid: true },
        min_seats: { value: shift.min_seats, modified: false, type: "min_seats", valid: true },
        max_seats: { value: shift.max_seats, modified: false, type: "max_seats", valid: true },
        interval: { value: shift.interval, modified: false, type: "integer", valid: true },
        active: { value: shift.active, modified: false, type: "boolean", valid: true },
        shift_seats_limit: { value: shift.shift_seats_limit, modified: false, type: "shift_seats_limit", valid: true },
        shift_limit_active: { value: shift.shift_limit_active, modified: false, type: "shift_limit_active", valid: true },
        interval_seats_limit: { value: shift.interval_seats_limit, modified: false, type: "interval_seats_limit", valid: true },
        interval_limit_active: { value: shift.interval_limit_active, modified: false, type: "interval_limit_active", valid: true },
        override_before_service: { value: shift.override_before_service, modified: false, type: "boolean", valid: true },
        duration_before_service: { value: shift.duration_before_service, modified: false, type: "boolean", valid: true },
        reservation_before_duration: { value: shift.reservation_before_duration, modified: false, type: 'duration', valid: true },
        message: { value: shift.message, modified: false, type: 'string', valid: true },
        show_message: { value: shift.show_message, modified: false, type: "boolean", valid: true },
    }
};

export const formToCustomShift = (form) => {
    return {
        id: form.id.value,
        date: form.date.value,
        shift: form.shift.value,
        from_hour: form.from_hour.value,
        to_hour: form.to_hour.value,
        min_seats: form.min_seats.value,
        max_seats: form.max_seats.value,
        interval: form.interval.value,
        active: form.active.value,
        shift_limit_active: form.shift_limit_active.value,
        shift_seats_limit: form.shift_seats_limit.value,
        interval_limit_active: form.interval_limit_active.value,
        interval_seats_limit: form.interval_seats_limit.value,
        override_before_service: form.override_before_service.value,
        duration_before_service: form.duration_before_service.value,
        reservation_before_duration: form.reservation_before_duration.value,
        message: form.message.value,
        show_message: form.show_message.value,
    }
}

export const validateShiftForm = (form) => {
    if (form.shift_limit_active.value && form.interval_limit_active.value &&
        form.interval_seats_limit.value > form.shift_seats_limit.value) {
        form.interval_seats_limit.valid = false;
    }
    else {
        form.interval_seats_limit.valid = true;
    }
}

export const getInitClosedDayForm = () => {
    return {
        id: { value: null, modified: false, type: "id", valid: true },
        from_day: { value: "", modified: false, type: "not-empty-string", valid: false },
        to_day: { value: "", modified: false, type: "not-empty-string", valid: false },
    }
};

export const closedDayToForm = (closedDay) => {
    return {
        id: { value: closedDay.id, modified: false, type: "id", valid: true },
        from_day: { value: closedDay.from_day, modified: false, type: "not-empty-string", valid: false },
        to_day: { value: closedDay.to_day, modified: false, type: "not-empty-string", valid: false },
    }
};

export const formToClosedDay = (form) => {
    return {
        id: form.id.value,
        from_day: form.from_day.value,
        to_day: form.to_day.value,
    }
}

export const getComputedShift = (shift) => {
    const from_hour_moment = timeToMoment(shift.from_hour);
    const to_hour_moment = timeToMoment(shift.to_hour);

    return {
        ...shift,
        from_hour_moment,
        to_hour_moment,
        from_hour: from_hour_moment.format(DISPLAY_TIME_FORMAT),
        to_hour: to_hour_moment.format(DISPLAY_TIME_FORMAT),
    };
};

export const sortShiftByFromHourCallback = (shiftA, shiftB) => {
    return shiftA.from_hour.localeCompare(shiftB.from_hour);
}

export const sortShiftByDateCallback = (shiftA, shiftB) => {
    if (shiftA.date === null && shiftB.date !== null) return 1;
    if (shiftA.date !== null && shiftB.date === null) return -1;
    if (shiftA.date === null && shiftB.date === null) return 0;
    return moment(shiftA.date, DATE_FORMAT) - moment(shiftB.date, DATE_FORMAT);
}

export const sortShiftByWeekdayCallback = (shiftA, shiftB) => {
    return shiftA.weekday - shiftB.weekday;
}

export const sortShiftByFullTimeCallback = (shiftA, shiftB) => {
    
    const weekdayComparison = sortShiftByWeekdayCallback(shiftA, shiftB);
    if(weekdayComparison !== 0)
        return weekdayComparison;

    const dateComparison = sortShiftByDateCallback(shiftA, shiftB);
    if(dateComparison !== 0)
        return dateComparison;

    const fromHourComparison = sortShiftByFromHourCallback(shiftA, shiftB);
    if(fromHourComparison !== 0)
        return fromHourComparison;

    return sortByIdCallback(shiftA, shiftB);
}

/**
 * 
 * @param {any[]} shifts 
 * @returns {any[]}
 */
export const getSortedShifts = (shifts) => {
    return shifts.sort((a, b) => {
        const ma = moment(a.from_hour, "HH:mm:ss");
        const mb = moment(b.from_hour, "HH:mm:ss");

        if (ma.isSame(mb)) {
            return sortByIdCallback(a, b);
        }

        return ma - mb;
    });
}

/**
 * 
 * @param {any[]} shifts 
 * @returns {any[]}
 */
export const getSortedShiftsById = shifts => {
    return shifts.sort(sortByIdCallback);
}

/**
 * 
 * @param {moment.Moment} selectedDate 
 * @param {any[]} shifts 
 * @returns 
 */
export const getActualShifts = (selectedDate, shifts) => {

    // if(isPassedDate(selectedDate, moment().subtract(1, 'day').startOf('day'))) {
    //     return [];
    // }

    const shiftsToDisplay = new Map();

    getSortedShiftsById(shifts)
        .filter(shift => {
            const isSelectedDate = selectedDate.format(DATE_FORMAT) === shift.date;
            const isShiftDateNull = shift.date === null;
            const isForSelectedDay = selectedDate.weekday() === shift.weekday;

            return isSelectedDate || (isForSelectedDay && isShiftDateNull);
        })
        .forEach(shift => {
            if (shift.shift && shiftsToDisplay.has(shift.shift)) {
                shiftsToDisplay.delete(shift.shift);
            }
            shiftsToDisplay.set(shift.id, shift);
        });

    return getSortedShifts(Array.from(shiftsToDisplay.values()));
}

/**
 * 
 * @param {moment.Moment} selectedDay 
 * @param {any[]} shifts 
 * @returns {any[]}
 */
export const getActualComputedShifts = (selectedDay, shifts = []) => (
    getActualShifts(selectedDay, shifts).map(v => {
        const from_hour_moment = timeToMoment(v.from_hour);
        const to_hour_moment = timeToMoment(v.to_hour);
        return {
            ...v,
            from_hour: from_hour_moment.format(DISPLAY_TIME_FORMAT),
            to_hour: to_hour_moment.format(DISPLAY_TIME_FORMAT),
            from_hour_moment,
            to_hour_moment,
        };
    })
);

/**
 * 
 * @param {any} target 
 * @param {any[]} shifts 
 * @returns {boolean}
 */
export const hasOverlap = (target, shifts) => {
    const target_from_hour = moment(target.from_hour, TIME_FORMAT);
    const target_to_hour = moment(target.to_hour, TIME_FORMAT);

    const overlapedShift = shifts.find(shift => {
        const from_hour = moment(shift.from_hour, TIME_FORMAT);
        const to_hour = moment(shift.to_hour, TIME_FORMAT);

        return (target.shift !== shift.id) &&
            (target.id !== shift.id) &&
            (
                target_from_hour.isBetween(from_hour, to_hour) ||
                target_to_hour.isBetween(from_hour, to_hour) ||
                (target_from_hour.isSameOrBefore(from_hour) && target_to_hour.isSameOrAfter(to_hour))
            );
    });

    return !!overlapedShift;
}

/**
 * This map represents value field key linked to their boolean field key.
 * If the boolean value of the right key is falsy, the value of the left key should be ignored.
 * This is quite a messy solution to be honest. We must a better way to organize occasional shift in the V2
 * in order to avoid this kind of bad practice.
 */
const SHIFT_RELATED_FIELDS = {
    message: 'show_message',
    interval_seats_limit: 'interval_limit_active',
    shift_seats_limit: 'shift_limit_active',
    reservation_before_duration: 'override_before_service',
    duration_before_service: 'override_before_service',
};

export const shiftPredicate = key => !(["id", "shift", "updated_at", "created_at", "date", "weekday"].includes(key) || /.+_moment$/.test(key));

export const shiftSanitizer = ([key, value], index, entries, object) => {

    if(key in SHIFT_RELATED_FIELDS) {
        // Looking for values to set to null if their boolean is false.
        const relatedFieldKey = SHIFT_RELATED_FIELDS[key];

        const [_, relatedValue] = entries.find(([k,_]) => k === relatedFieldKey) ?? [];

        if(relatedValue === false)
            return null;
    }

    if (TIME_REGEX.test(value)) {
        const timeMoment = timeToMoment(value, DISPLAY_TIME_FORMAT);
        return timeMoment.format(TIME_FORMAT);
    }

    if (value === "") {
        return null;
    }

    return value;
};

/**
 * 
 * @param {Record<string, unknown>} shiftA 
 * @param {Record<string, unknown>} shiftB
 * @returns {boolean}
 */
export function areSameShifts(shiftA, shiftB, predicate = shiftPredicate, sanitizer = shiftSanitizer) {
    const filteredA = filterObjectKeys(shiftA, predicate);
    const filteredB = filterObjectKeys(shiftB, predicate);

    const sanitizedA = sanitizeObject(filteredA, sanitizer);
    const sanitizedB = sanitizeObject(filteredB, sanitizer);

    return isEqual(sanitizedA, sanitizedB);
}

/**
 * 
 * @param {moment.Moment | string} day 
 * @param {any[]} closedDates 
 */
export const isDayClosed = (day, closedDays = []) => {
    const dateMoment = moment(day);

    for (const closedDay of closedDays) {
        const from_day = moment(closedDay.from_day);
        const to_day = moment(closedDay.to_day);

        if (dateMoment.isBetween(from_day, to_day, undefined, "[]"))
            return true;
    }
    return false;
}

/**
 * Returns the current shift from a list for the selected time given.
 * @param {moment.Moment} selectedMoment 
 * @param {Record<string, unknown>[]} shifts 
 * @returns 
 */
export function getShiftFromMoment(selectedMoment = moment(), shifts = []) {
    const allShifts = toSorted(shifts, sortShiftByFullTimeCallback);
    const startMoment = moment(selectedMoment);
    const startMomentWeekday = startMoment.isoWeekday() - 1;
    const startMomentDate = startMoment.format(DATE_FORMAT);

    // Getting shifts in which the startTime is included. 
    const foundShifts = allShifts
        .filter(shift => {

            const isNotSameWeekday = shift.weekday !== startMomentWeekday;
            const isNotSameDateIfExists = shift.date !== null && shift.date !== startMomentDate;
            
            if (isNotSameWeekday || isNotSameDateIfExists)
                return false;
            
            const shiftFromMoment = setTimeFromString(startMoment, shift.from_hour);
            const shiftToMoment = setTimeFromString(startMoment, shift.to_hour);
            return startMoment.isBetween(shiftFromMoment, shiftToMoment, undefined, '[)');
        });
    
    const result = foundShifts.reduce((previousShift, currentShift) => {
        const doesPreviousReplaceCurrent = previousShift?.shift === currentShift.id;
        return doesPreviousReplaceCurrent ? previousShift : currentShift;
    }, null);

    return result;
}


// WEBPACK FOOTER //
// ./src/helpers/shifts.js